module.exports = __webpack_public_path__ + "img/DE05712.4085bb1f.png";